module.exports = __webpack_public_path__ + "img/logo.2680f10b.png";